//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const EB1382LoginPageContentDisplay: FeatureFlag = {"Id":"EB1382LoginPageContentDisplay","Label":"(KILL)[10.26]EB1382LoginPageContentDisplay","Impact":"DON'T TOUCH UNLESS DIRECTED BY A DEVELOPER. Kill switch for the fix to EB-1382. When active, unauthenticated visitors who reach a MustLogin segment via a resume/invite link will see either the segment's configured Login Page Content or the Introduction's content instead of a generic not-found page. When disabled, the previous behavior is preserved (always shows generic not-found page).","Mode":3,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":7};
